import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) { }

  /**
 * Agency list
 * @param Object none
 * @return Object Resultset
 */
  agencyList(searchData: any): Observable<any> {
    const url = this.envService.apiUrl + 'agencies/list';
    return this.http.post<any>(url, searchData).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  listPeoples(): Observable<any> {
    const url = this.envService.mockUrl + 'test/list';
    return this.http.get<any>(url);
  }

  /**
   * Function to save an agency
   * @param agencyInfo : adency data object
   */
  saveAgency(agencyInfo): Observable<any> {
    const url = this.envService.apiUrl + 'agency';
    return this.http.post(url, agencyInfo).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

    /**
   * Function to save an agency
   * @param reportingunitInfo : adency data object
   */
  saveReportingUnit(reportingunitInfo): Observable<any> {
    const url = this.envService.apiUrl + 'reportingunit';
    return this.http.post(url, reportingunitInfo).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  /**
   * Function to update the agency info
   * @param any agencyInfo
   */
  editAgency(agencyInfo): Observable<any> {
    const url = this.envService.apiUrl + 'agency';
    return this.http.put<any>(url, agencyInfo).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Function to return agency information from agency Index
   * @param any agencyIndex
   */
  getAgencyByIndex(agencyIndex): Observable<any> {
    const url = this.envService.apiUrl + 'agency/' + agencyIndex;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * delete agency
   *
   */
  deleteAgencydata(agencyIndex): Observable<any> {
    const url = this.envService.apiUrl + 'agency/' + agencyIndex;
    return this.http.delete<any>(url, agencyIndex).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  setDefaultAgency(data) {
    const url = this.envService.apiUrl + 'helpers/SetSuperAdminDefaultAgency';
    return this.http.put<any>(url, data).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
